export const MAX_FILE_SIZE_MB = 10;
export const MAX_FILES = 5;
export const MAX_TOTAL_SIZE_MB = 50;

export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
export const MAX_TOTAL_SIZE_BYTES = MAX_TOTAL_SIZE_MB * 1024 * 1024;

export const ACCEPTED_FILE_TYPES = ".pdf,.doc,.docx,.rtf,.txt";
export const ACCEPTED_EXTENSIONS = ["pdf", "doc", "docx", "rtf", "txt"] as const;

export const PROCESSING_LEAVE_PROMPT =
    "Trwa generowanie artykułu przez AI. Na pewno chcesz opuścić stronę?";
export const PROCESSING_BACK_PROMPT =
    "Trwa generowanie artykułu przez AI. Na pewno chcesz cofnąć?";
